<mat-form-field
  appearance="outline"
  [ngClass]="{ failed: !!UOMValidation || !validSnapshot || !!warning, capitalized: capitalized }"
  class="miq-form-input"
>
  <mat-select
    hideSingleSelectionIndicator="true"
    #select
    [placeholder]="!!placeholder ? placeholder : ('shared.select' | xTranslate)"
    [required]="required"
    [formControl]="fc"
    [panelClass]="panelClass"
    (selectionChange)="onChange($event.value)"
    (focus)="select.open()"
    [disabled]="disabled"
    disableOptionCentering
  >
    <mat-option (click)="select.close()" [value]="null">--</mat-option>
    <mat-option
      (click)="select.close()"
      *ngFor="let val of values"
      [value]="val[dataKey]"
      [disabled]="
        (val[dataKey] === noPrivacyConfidentiality && isRecordPrivate) || val[dataKey] > userConfidentialityLevel
      "
      [ngClass]="{ capitalized: capitalized }"
    >
      {{ val.value }}
    </mat-option>
  </mat-select>
</mat-form-field>
